import moment from 'moment'
import React, { Component } from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Scrollchor from 'react-scrollchor'
import { Field, reduxForm } from 'redux-form'
import * as actions from '../../actions'
import { ADD_ERROR } from '../../actions/types'
import CustomSweetAlert from '../Alerts/SweetAlert'
import RenderDateField from '../booking/renderDateField'
import RenderField from '../booking/renderField'
import RenderMAWB from '../booking/renderMAWB'
import RenderStatusField from '../booking/renderStatusField'
import UploadModal from '../renderUploadModal'
import Spinner from '../util/spinner'

class BookingHeaderCustomer extends Component {
  componentDidMount() {
    // console.log(this.props.match.params);
    const { BookingID } = this.props.match.params
    this.props.fetchBookingHeader(BookingID)
    if (this.props.user.accessLevel === 'CUSTOMER') {
      if (this.props.user.CustomerID !== this.props.booking.CNeeID.toString()) {
        this.props.history.push('/p/search')
        this.props.dispatch(this.addError('ACCESS DENIED'))
      }
    }
  }

  addError(error) {
    return {
      type: ADD_ERROR,
      payload: error,
    }
  }

  render() {
    const { booking, initialValues, handleSubmit, uploaded } = this.props
    if (!booking || !initialValues) {
      return <Spinner />
    }

    if (
      this.props.user.accessLevel === 'CUSTOMER' &&
      String(this.props.user.CustomerID) === '10561'
    ) {
      const fourMonthsAgo = new Date()
      fourMonthsAgo.setMonth(fourMonthsAgo.getMonth() - 4)

      const createDate = new Date(booking.createDate)

      if (createDate < fourMonthsAgo) {
        this.props.history.push('/p/search')
        return null
      }
    }

    return (
      <fieldset className="for-panel">
        <Button bsSize="small">
          <Scrollchor to="#comments" style={{ color: 'inherit' }}>
            Comments
          </Scrollchor>
        </Button>
        <div className="row">
          <div className="col-sm-6">Prepare By: {booking.PrepareBy}</div>
          <div className="col-sm-6">
            <ButtonToolbar className="pull-right button-lineup">
              <Button
                bsSize="small"
                bsStyle="default"
                onClick={this.props.openModal}
              >
                Upload
              </Button>
              <Button
                bsSize="small"
                bsStyle="default"
                href={`/p/sendmail/${booking.BookingID}`}
              >
                Send Notification
              </Button>
            </ButtonToolbar>
          </div>
          <UploadModal
            url={`sfo_uploads/${booking.CNeeID}`}
            showModal={this.props.showModal}
            closeModal={this.props.closeModal}
          />
          {uploaded && uploaded.status === 'ok' ? (
            <CustomSweetAlert type="success" title={uploaded.message} />
          ) : null}
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-6 ">
              <strong>
                BOOKING{' '}
                <span style={{ color: 'red' }}>({booking.ShipmentType})</span> #{' '}
              </strong>
              {booking.BookingID} -- created on{' '}
              {moment(booking.createDate).format('MM/DD/YYYY hh:mm A')}
            </div>
            <div className="col-sm-6 pull-right button-lineup">
              <strong>Consignee:</strong> [{booking.CNeeID}] {booking.CNeeName}
            </div>
          </div>

          <hr />
          <div className="row">
            <Field
              label="Flight No:"
              name="FlightNo"
              component={RenderField}
              disabled
            />
            <Field
              label="Booking Status:"
              name="bkStatus"
              component={RenderStatusField}
              disabled
            />
          </div>
          <div className="row">
            <Field
              label="Connecting Flight No:"
              name="ConnectingFlightNo"
              component={RenderField}
              disabled
            />
            <Field
              label="Shpmt. buying terms:"
              type="text"
              name="buyTerm"
              component={RenderField}
              disabled
            />
          </div>
          <div className="row">
            <Field
              label="ISF File Date:"
              type="text"
              name="ISFDate"
              component={RenderDateField}
              disabled
            />
            <Field
              label="Master AWB:"
              type="text"
              name="mawb"
              component={RenderMAWB}
              disabled
            />
          </div>
          <div className="row">
            <Field
              label="Original Port:"
              type="text"
              name="OrgPort"
              component={RenderField}
              disabled
            />
            <Field
              label="ETD:"
              type="text"
              name="ETD"
              component={RenderDateField}
              disabled
            />
          </div>
          <div className="row">
            <Field
              label="Transit Port:"
              type="text"
              name="DstPort"
              component={RenderField}
              disabled
            />
            <Field
              label="(Transit Port) ETA:"
              type="text"
              name="ETAFirst"
              component={RenderDateField}
              disabled
            />
          </div>
          <div className="row">
            <Field
              label="Final Destination:"
              type="text"
              name="FnlPort"
              component={RenderField}
              disabled
            />
            <Field
              label="(Final port) ETA:"
              type="text"
              name="ETAFinal"
              component={RenderDateField}
              disabled
            />
          </div>
          <div className="row">
            <Field
              label="Document Send Date:"
              type="text"
              name="docSend"
              component={RenderDateField}
              disabled
            />
            <Field
              label="Approval Cut Off:"
              type="text"
              name="AprvCutOff"
              component={RenderDateField}
              disabled
            />
          </div>
        </form>
      </fieldset>
    )
  }
}

function mapStateToProps({ bookings, auth, util }) {
  return {
    initialValues: bookings.bookingHeader,
    booking: bookings.bookingHeader,
    user: auth.user,
    showModal: util.showModal,
    uploaded: util.uploaded,
    errorMessage: util.errors,
  }
}

BookingHeaderCustomer = reduxForm({
  form: 'BookingHeaderCustomer',
  enableReinitialize: true,
})(BookingHeaderCustomer)

BookingHeaderCustomer = withRouter(
  connect(mapStateToProps, actions)(BookingHeaderCustomer),
)
export default BookingHeaderCustomer
